import { render, staticRenderFns } from "./CulturePromotionContentPostInfo.vue?vue&type=template&id=2ae2577c&scoped=true&"
import script from "./CulturePromotionContentPostInfo.vue?vue&type=script&lang=js&"
export * from "./CulturePromotionContentPostInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2577c",
  null
  
)

export default component.exports